"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Caption = exports.Paragraph = exports.paragraphLargeStyling = exports.paragraphXSmallStyling = exports.paragraphSmallStyling = exports.paragraphStyling = exports.HeadingSmall = exports.headingSmallStyling = exports.HeadingMedium = exports.headingMediumStyling = exports.HeadingLarge = exports.headingLargeStyling = exports.Headline = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _StyledLayout = require("../StyledLayout");

var _StyleGuide = require("../StyleGuide");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-nested-ternary */
var linkStyling = (0, _styledComponents.css)(["a{", ";}", ""], _StyleGuide.fontColor, function (props) {
  return props.noHover && (0, _styledComponents.css)(["&:hover,a,a:hover{", ";}"], _StyleGuide.fontColor);
});

var Headline = _styledComponents["default"].h1.withConfig({
  displayName: "StyledTypography__Headline",
  componentId: "sc-1un6cv3-0"
})(["font-size:", ";line-height:", ";margin:0;font-weight:bold;@media (min-width:", "px){font-size:", ";line-height:", ";letter-spacing:-0.4px;}", ";", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return props.theme.fontSizeHeadlineMobile;
}, function (props) {
  return props.theme.lineHeightHeadlineMobile;
}, function (props) {
  return props.theme.responsiveMedium;
}, function (props) {
  return props.theme.fontSizeHeadline;
}, function (props) {
  return props.theme.lineHeightHeadline;
}, _StyleGuide.fontColor, _StyleGuide.fontWeight, _StyledLayout.spacing, _StyledLayout.overflow, _StyleGuide.textAlign, _StyledLayout.display, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.Headline = Headline;
var headingLargeStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";font-weight:bold;text-transform:none;margin:0;"], function (props) {
  return props.theme.fontSizeHeadingLarge;
}, function (props) {
  return props.theme.lineHeightHeadingLarge;
});
exports.headingLargeStyling = headingLargeStyling;

var HeadingLarge = _styledComponents["default"].h2.withConfig({
  displayName: "StyledTypography__HeadingLarge",
  componentId: "sc-1un6cv3-1"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], headingLargeStyling, _StyleGuide.fontColor, _StyleGuide.fontWeight, _StyledLayout.spacing, _StyledLayout.overflow, _StyleGuide.textAlign, _StyledLayout.display, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.HeadingLarge = HeadingLarge;
var headingMediumStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";font-weight:bold;text-transform:none;margin:0;"], function (props) {
  return props.theme.fontSizeHeadingMedium;
}, function (props) {
  return props.theme.lineHeightHeadingMedium;
});
exports.headingMediumStyling = headingMediumStyling;

var HeadingMedium = _styledComponents["default"].h3.withConfig({
  displayName: "StyledTypography__HeadingMedium",
  componentId: "sc-1un6cv3-2"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], headingMediumStyling, _StyleGuide.fontColor, _StyleGuide.fontWeight, _StyledLayout.spacing, _StyledLayout.overflow, _StyleGuide.textAlign, _StyledLayout.display, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.HeadingMedium = HeadingMedium;
var headingSmallStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";font-weight:bold;text-transform:none;margin:0;"], function (props) {
  return props.theme.fontSizeHeadingSmall;
}, function (props) {
  return props.theme.lineHeightHeadingSmall;
});
exports.headingSmallStyling = headingSmallStyling;

var HeadingSmall = _styledComponents["default"].h4.withConfig({
  displayName: "StyledTypography__HeadingSmall",
  componentId: "sc-1un6cv3-3"
})(["", " ", ";", ";", ";", ";", ";", ";", ";", ";", ";"], headingSmallStyling, _StyleGuide.fontColor, _StyleGuide.fontWeight, _StyledLayout.spacing, _StyledLayout.overflow, _StyleGuide.textAlign, _StyledLayout.display, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.HeadingSmall = HeadingSmall;
var paragraphStyling = (0, _styledComponents.css)(["align-self:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.align === 'center' && 'center';
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.lineHeightBody;
});
exports.paragraphStyling = paragraphStyling;
var paragraphSmallStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeBodySmall;
}, function (props) {
  return props.theme.lineHeightBodySmall;
});
exports.paragraphSmallStyling = paragraphSmallStyling;
var paragraphXSmallStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeBodyXSmall;
}, function (props) {
  return props.theme.lineHeightBodyXSmall;
});
exports.paragraphXSmallStyling = paragraphXSmallStyling;
var paragraphLargeStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeBodyLarge;
}, function (props) {
  return props.theme.lineHeightBodyLarge;
});
exports.paragraphLargeStyling = paragraphLargeStyling;

var Paragraph = _styledComponents["default"].p.withConfig({
  displayName: "StyledTypography__Paragraph",
  componentId: "sc-1un6cv3-4"
})(["", ";", " ", " ", " letter-spacing:0px;text-transform:none;margin:0;", " ", " ", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], paragraphStyling, function (props) {
  return props.xSmall && (0, _styledComponents.css)(["", ";"], paragraphXSmallStyling);
}, function (props) {
  return props.small && (0, _styledComponents.css)(["", ";"], paragraphSmallStyling);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["", ";"], paragraphLargeStyling);
}, function (props) {
  return props.body && (0, _styledComponents.css)(["margin:0 0 ", " 0;&:last-of-type{margin:0px;};"], props.theme.spacingSm);
}, function (props) {
  return props.showWhiteSpace && (0, _styledComponents.css)(["white-space:pre-wrap;word-break:break-word;"]);
}, function (props) {
  return props.clampedSingleLine && (0, _styledComponents.css)(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
}, _StyleGuide.fontColor, _StyledLayout.spacing, _StyleGuide.textAlign, _StyledLayout.overflow, _StyleGuide.fontWeight, _StyleGuide.fontStyle, _StyledLayout.display, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.Paragraph = Paragraph;

var Caption = _styledComponents["default"].p.withConfig({
  displayName: "StyledTypography__Caption",
  componentId: "sc-1un6cv3-5"
})(["font-size:", ";line-height:", ";text-transform:none;margin:0;", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
  return props.theme.fontSizeCaption;
}, function (props) {
  return props.theme.lineHeightCaption;
}, _StyleGuide.fontColor, _StyledLayout.spacing, _StyleGuide.textAlign, _StyledLayout.overflow, _StyleGuide.fontWeight, _StyleGuide.textFormatting, _StyleGuide.fontFamily, linkStyling);

exports.Caption = Caption;